module.exports = __webpack_public_path__ + "img/pic__photo_04@2x.fde29163.png";